<template>
    <div ref="user"></div>
</template>

<script>
import User from "!!raw-loader!../../assets/ricoh_assets/icons/ICN001-01_user.svg" // loads SVG Icons as String via Webpack.
export default {
    mounted() {
        let shadowRoot = this.$refs.user.attachShadow({mode: 'open'})
        shadowRoot.innerHTML = User

        const style = document.createElement('style')
        style.innerHTML = `svg { width: 100%; height: 100%; }`

        const clonedStyle = style.cloneNode(true)
        shadowRoot.appendChild(clonedStyle)
    }
}
</script>
<style>
</style>